import { axios } from "@/plugins/axios"


export default {
    namespaced: true,

    state: {
        gradoHomologado: [],
    },

    getters: {
        getGradoHomologado: (state) => {
            return state.gradoHomologado
        },
    },

    mutations: {
        SET_GRADO_HOMOLOGADO(state, grado) {
            state.gradoHomologado = grado
        },
    },

    actions: {
        fetchGradoHomologado: async function ({ commit }) {
            await axios
                .get('/PoliciaCuadrantes/EstadoFuerza/catgradohomologado')
                .then((response) => {
                    commit('SET_GRADO_HOMOLOGADO', response.data.data)
                })
              
        },
    },
}
